<script>

export default {
    name: 'dt-nav',
    props: {
        pages: {
            type: Array,
            default: _ => [],
        },
    },
    data() {
        return {
            isCollapsed: false,
        }
    },
    watch: {
        windowW() {
            if(this.windowW < 700 && !this.isCollapsed)
                this.toggle(700)
        },
        windowH() {
            if(this.windowH < 500 && !this.isCollapsed)
                this.toggle(700)
        },
        $route() {
            if((this.windowW < 700 || this.windowH < 500) && !this.isCollapsed)
                this.toggle(500)
        },
    },
    methods: {
        toggle(dt=0) {
            return
            setTimeout(_ => {this.isCollapsed = !this.isCollapsed}, dt)
        },
    },
}
</script>

<template lang="pug">

div.dt-nav(
    :class="{'dt-nav_collapsed': isCollapsed}")
    transition(name="dt-nav__body1")
        div.dt-nav__body(
            v-show="!isCollapsed")
            router-link.dt-nav__item(
                tag="div",
                v-for="route of pages",
                :key="route.name",
                :class=`{
                    'dt-nav__item_pushed': $route.name == route.name
                }`,
                :to="{name: route.name, params: route.params || {}}")
                | {{ route.title }}
    //
        transition(name="dt-nav__footer1")
            div.dt-nav__footer(
                v-show="isCollapsed")
        md-button.dt-nav__toggle(
            :class="{'dt-nav__toggle_collapsed': isCollapsed}"
            @click="toggle")
            md-icon(:class=`{
                'size-4x': windowW > 700,
                'size-3x': windowW > 500 && windowW<= 700,
                'size-2x': windowW<= 500,
                }`) menu
</template>

<style lang="sass">

@import '~@dt/sass/root.sass'

.dt-nav
    position: relative
    &__body
        max-height: 500px
        +flex()
        +flex-wrap(wrap, $micro: nowrap)
        +flex-direction(row, $micro: column)
        +flex-justify(space-around, $micro: flex-start)
        +padding($micro: 5px 10px)
        +color-back(light3)
        &-leave-to
            max-height: 0
        &-enter
            max-height: 0
        &-leave-active
            transition: max-height 1s ease-in
        &-enter-active
            transition: max-height 1s ease-out
    &__item
        flex: 1 0 10%
        +flex(row, nowrap, center, center)
        +margin($micro: 5px)
        +padding(15px, 13px 10px, 11px 5px, 10px 2px)
        +border(sep-micro)
        +color(light3, light)
        +font(extra)
        text-decoration: none
        &:hover
            +color(dark2, light)
            text-decoration: underline
            cursor: pointer
        &_pushed
            +color(light3, light1)
            text-decoration: underline
            cursor: default
            &:hover
                +color(light3, light1)
                text-decoration: underline
                cursor: default
        &_semi-pushed
            +color(dark2, light)
            text-decoration: underline
            &:hover
                +color(dark3, light)
                text-decoration: underline
                cursor: pointer
    &__footer
        position: absolute
        width: 100%
        height: 10px
        z-index: 1000
        +color-back(light3)
        &-leave-to
            height: 0
        &-enter
            height: 0
        &-leave-active
            transition: height .1s ease-in 1s
        &-enter-active
            transition: height .1s ease-in .8s
    &__toggle
        position: absolute
        left: 0
        bottom: 100%
        z-index: 10000
        +width(160px, $milli: 128px, $nano: 80px)
        margin: 0
        +color(light3, light)
        &:hover
            +color(light3, light)
            cursor: pointer
</style>



// WEBPACK FOOTER //
// site/deeptensor/components/Nav.vue